const SignIn = () => import('./components/SignIn')

export default [
  {
    name: 'signin',
    path: '/singin',
    component: SignIn,
    meta: {
      requiresAuth: false,
      hideNavbar: true
    }
  }
]
